import * as React from "react"
import DoneIcon from "@mui/icons-material/Done"
import ScheduleRounded from "@mui/icons-material/ScheduleRounded"
import ClearRounded from "@mui/icons-material/ClearRounded"
import WarningAmberRounded from "@mui/icons-material/WarningAmberRounded"
import RemoveCircleOutlineRounded from "@mui/icons-material/RemoveCircleOutlineRounded"
import Chip from "@mui/material/Chip"
import { GridRenderCellParams } from "@mui/x-data-grid"
import { styled } from "@mui/material"
import { ReservationStatus } from "components/Firebase"

const StyledChip = styled(Chip)(({ theme }) => ({
    justifyContent: "left",
    "& .icon": {
        color: "inherit"
    },
    "&.Confirmed": {
        border: `2px solid ${theme.palette.confirmed}`
    },
    "&.Pending": {
        border: `2px solid ${theme.palette.pending}`
    },
    "&.Declined": {
        border: `2px solid ${theme.palette.declined}`
    },
    "&.Canceled": {
        color: "#aaa",
        border: `2px solid #aaa`
    },
    "&.Abused": {
        border: `2px solid ${theme.palette.declined}`
    }
}))

interface StatusProps {
    status: string
}

const Status = React.memo((props: StatusProps) => {
    const { status } = props

    let icon: any = null
    const lowerStatus = status.toLowerCase()
    if (lowerStatus === ReservationStatus.Confirmed) {
        icon = <DoneIcon className="icon" />
    } else if (lowerStatus === ReservationStatus.Pending) {
        icon = <ScheduleRounded className="icon" />
    } else if (lowerStatus === ReservationStatus.Declined) {
        icon = <ClearRounded className="icon" />
    } else if (lowerStatus === ReservationStatus.Canceled) {
        icon = <RemoveCircleOutlineRounded className="icon" />
    } else if (lowerStatus === ReservationStatus.Abused) {
        icon = <WarningAmberRounded className="icon" />
    }

    return <StyledChip className={status} icon={icon} size="small" label={status} variant="outlined" />
})

export function renderStatus(params: GridRenderCellParams<any, string>) {
    if (params.value == null) {
        return ""
    }

    const capitalised: string = params.value.charAt(0).toUpperCase() + params.value.slice(1).toLowerCase()
    return <Status status={capitalised} />
}
